import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { BackofficeSessionService } from './backoffice-session.service';
import {
  BackofficeScoreReportResponse,
  BackofficeScoreReportsListResponse
} from './backoffice-score-reports-api.types';

@Injectable({ providedIn: 'root' })
export class BackofficeScoreReportsApiService {
  private readonly http = inject(HttpClient);
  private readonly session = inject(BackofficeSessionService);
  private readonly apiBaseUrl = environment.apiBaseUrl;

  list(tournamentId: number): Observable<BackofficeScoreReportsListResponse> {
    return this.http.get<BackofficeScoreReportsListResponse>(
      `${this.apiBaseUrl}/api/backoffice/tournaments/${tournamentId}/score-reports`,
      { headers: this.authHeaders() }
    );
  }

  getById(tournamentId: number, reportId: number): Observable<BackofficeScoreReportResponse> {
    return this.http.get<BackofficeScoreReportResponse>(
      `${this.apiBaseUrl}/api/backoffice/tournaments/${tournamentId}/score-reports/${reportId}`,
      { headers: this.authHeaders() }
    );
  }

  decide(tournamentId: number, reportId: number, status: 'in_review' | 'validated' | 'rejected', note: string): Observable<BackofficeScoreReportResponse> {
    return this.http.post<BackofficeScoreReportResponse>(
      `${this.apiBaseUrl}/api/backoffice/tournaments/${tournamentId}/score-reports/${reportId}/decision`,
      { decision: { status, note } },
      { headers: this.authHeaders() }
    );
  }

  private authHeaders(): HttpHeaders {
    const token = this.session.token();
    return token ? new HttpHeaders({ Authorization: `Bearer ${token}` }) : new HttpHeaders();
  }
}
